<template lang="pug">
  .menu-develop
    v-menu(
      v-model="menuOpen"
      close-on-click
      close-on-content-click
      offset-y
      bottom)
      template(v-slot:activator="{ on }")
        v-btn(v-on="on" fab color="pink lighten-4" small)
          v-icon mdi-dev-to
      v-list.menu-develop__list
        v-list-item
          ButtonSelectRole(:roles="roles")
        v-list-item
          v-list-item-title(@click="goto('/home')")
            span dashboard
        v-list-item
          v-list-item-title(@click="goto('/fantasy/competitions')")
            span.green--text fantasy
            span / competitions/competiciones
        v-list-item
          v-list-item-title(@click="goto('/fantasy/matchsets')")
            span.green--text fantasy
            span / matchsets/jornadas
        v-list-item
          v-list-item-title(@click="goto('/fantasy/matches')")
            span.green--text fantasy
            span / matches
        v-list-item
          v-list-item-title(@click="goto('/fantasy/teams')")
            span.green--text fantasy
            span / teams
        v-list-item
          v-list-item-title(@click="goto('/fantasy/players')")
            span.green--text fantasy
            span / players
        v-list-item
          v-list-item-title(@click="goto('/fantasy/contests')")
            span.green--text fantasy
            span / contests/campeonatos
        v-list-item
          v-list-item-title(@click="goto('/fantasy/networks')")
            span.green--text fantasy
            span / networks
        v-list-item
          v-list-item-title(@click="goto('/fantasy/categories')")
            span.green--text fantasy
            span / categories
        v-list-item
          v-list-item-title(@click="goto('/casino/rtp')")
            span.pink--text.lighten-1 casino
            span / rtp
        v-list-item
          v-list-item-title(@click="goto('/casino/rounds')")
            span.pink--text.lighten-1 casino
            span / rounds
        v-list-item
          v-list-item-title(@click="goto('/casino/lobby')")
            span.pink--text.lighten-1 casino
            span / lobby
        v-list-item
          v-list-item-title(@click="goto('/campaigns/freespins')")
            span.blue--text.darken-4 campaign
            span / freespins
        v-list-item
          v-list-item-title(@click="goto('/campaigns/freerounds')")
            span.blue--text.darken-4 campaign
            span / freerounds
        v-list-item
          v-list-item-title(@click="goto('/campaigns/optin')")
            span.blue--text.darken-4 campaign
            span / opt-in
        v-list-item
          v-list-item-title(@click="goto('/campaigns/referafriend')")
            span.blue--text.darken-4 campaign
            span / refer a friend
        v-list-item
          v-list-item-title(@click="goto('/administrators')")
            span administrators
        v-list-item
          v-list-item-title(@click="goto('/users')")
            span users
        v-list-item
          v-list-item-title(@click="goto('/games')")
            span games
        v-list-item
          v-list-item-title(@click="goto('/providers')")
            span providers
        v-list-item
          v-list-item-title(@click="goto('/operators')")
            span operators
        v-list-item
          v-list-item-title(@click="goto('/finances')")
            span finances
        v-list-item
          v-list-item-title(@click="goto('/tournaments')")
            span tournaments
</template>

<script>
  import ButtonSelectRole from '@/components/develop/ButtonSelectRole';
  import { roles } from '@/store/variablesGlobals';

  export default {
    name: "MenuDevelop",
    components: {
      ButtonSelectRole
    },
    data: () => ({
      fakeToken: "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpZCI6IjVlN2MwMDBkOGJkNmY4M2E0Zjg1YWRkOCIsInBpbiI6IjYyOTkzNSIsInVzZXJpZCI6IjVlN2MwMDBkOGJkNmY4M2E0Zjg1YWRkOCIsImlhdCI6MTU4NjA5NjU2NX0.VosbtoPDX9ke1BD9AXqjeTj0oYeajJjb17L_3SIEy_c",
      fakeUser: {name: "Develop", id: "5e7c000d8bd6f83a4f85add8", email: "samurai.dani@gmail.com", rol: "superuser"},
      menuOpen: false,
      roles: roles,
    }),
    methods: {
      goto(url){
        if(this.$store.state.login.token == ''){
          this.$store.commit('setUserState', this.fakeUser);
          this.$store.commit('setUserToken', this.fakeToken);
          this.$store.commit('setUserRole', 'superuser');
        }
        if(this.$route.path != url){
          this.$router.push(url);
        }
      },
    }
  }
</script>

<style lang="sass">
.menu-develop
  position: fixed
  top: 0
  left: 50%
  transform: translateX(-50%)
  z-index: 100
  &__list .v-list-item
    min-height: 32px
    padding: 0
  &__list .v-list-item__title
    cursor: pointer
    line-height: 32px
    padding: 0 16px
    &:hover
      background-color: lighten(#ff7500, 20%)
</style>